import {
  GET_CUSTOM_PAYMENT_TYPES_REQUESTED,
  GET_CUSTOM_PAYMENT_TYPES_SUCCEEDED,
  GET_CUSTOM_PAYMENT_TYPES_FAILED,
  CREATE_CUSTOM_PAYMENT_TYPES_REQUESTED,
  CREATE_CUSTOM_PAYMENT_TYPES_SUCCEEDED,
  CREATE_CUSTOM_PAYMENT_TYPES_FAILED,
  UPDATE_CUSTOM_PAYMENT_TYPES_REQUESTED,
  UPDATE_CUSTOM_PAYMENT_TYPES_SUCCEEDED,
  UPDATE_CUSTOM_PAYMENT_TYPES_FAILED,
  DELETE_CUSTOM_PAYMENT_TYPES_REQUESTED,
  DELETE_CUSTOM_PAYMENT_TYPES_SUCCEEDED,
  DELETE_CUSTOM_PAYMENT_TYPES_FAILED,
  GET_FILTERED_AND_PAGINATED_CUSTOM_PAYMENT_TYPES_FAILED,
  GET_FILTERED_AND_PAGINATED_CUSTOM_PAYMENT_TYPES_REQUESTED,
  GET_FILTERED_AND_PAGINATED_CUSTOM_PAYMENT_TYPES_SUCCEEDED,
} from './constants'
import api from 'utils/api'

export const getCustomPaymentTypesRequested = () => ({
  type: GET_CUSTOM_PAYMENT_TYPES_REQUESTED,
})

export const getCustomPaymentTypesSucceeded = (payload) => ({
  type: GET_CUSTOM_PAYMENT_TYPES_SUCCEEDED,
  payload,
})

export const getCustomPaymentTypesFailed = () => ({
  type: GET_CUSTOM_PAYMENT_TYPES_FAILED,
})

export const getFilteredAndPaginatedCustomPaymentTypesRequested =
  () => ({
    type: GET_FILTERED_AND_PAGINATED_CUSTOM_PAYMENT_TYPES_REQUESTED,
  })

export const getFilteredAndPaginatedCustomPaymentTypesSucceeded = (
  payload
) => ({
  type: GET_FILTERED_AND_PAGINATED_CUSTOM_PAYMENT_TYPES_SUCCEEDED,
  payload,
})

export const getFilteredAndPaginatedCustomPaymentTypesFailed =
  () => ({
    type: GET_FILTERED_AND_PAGINATED_CUSTOM_PAYMENT_TYPES_FAILED,
  })

export const createCustomPaymentTypesRequested = () => ({
  type: CREATE_CUSTOM_PAYMENT_TYPES_REQUESTED,
})

export const createCustomPaymentTypesSucceeded = (payload) => ({
  type: CREATE_CUSTOM_PAYMENT_TYPES_SUCCEEDED,
  payload,
})

export const createCustomPaymentTypesFailed = () => ({
  type: CREATE_CUSTOM_PAYMENT_TYPES_FAILED,
})

export const updateCustomPaymentTypesRequested = () => ({
  type: UPDATE_CUSTOM_PAYMENT_TYPES_REQUESTED,
})

export const updateCustomPaymentTypesSucceeded = (payload) => ({
  type: UPDATE_CUSTOM_PAYMENT_TYPES_SUCCEEDED,
  payload,
})

export const updateCustomPaymentTypesFailed = () => ({
  type: UPDATE_CUSTOM_PAYMENT_TYPES_FAILED,
})

export const deleteCustomPaymentTypesRequested = () => ({
  type: DELETE_CUSTOM_PAYMENT_TYPES_REQUESTED,
})

export const deleteCustomPaymentTypesSucceeded = (payload) => ({
  type: DELETE_CUSTOM_PAYMENT_TYPES_SUCCEEDED,
  payload,
})

export const deleteCustomPaymentTypesFailed = () => ({
  type: DELETE_CUSTOM_PAYMENT_TYPES_FAILED,
})

// in order to fetch all custom payment types venueUuid is required to be passed as a parameter
export const fetchCustomPaymentTypes = (params) => (dispatch) => {
  dispatch(getCustomPaymentTypesRequested())

  return api
    .fetchCustomPaymentTypes(params)
    .then((response) =>
      dispatch(
        getCustomPaymentTypesSucceeded(
          response.data.customPaymentTypes
        )
      )
    )
    .catch(() => dispatch(getCustomPaymentTypesFailed()))
}

export const fetchFilteredAndPaginatedCustomPaymentTypes =
  (params) => (dispatch) => {
    dispatch(getFilteredAndPaginatedCustomPaymentTypesRequested())

    return api
      .fetchCustomPaymentTypes(params)
      .then((response) =>
        dispatch(
          getFilteredAndPaginatedCustomPaymentTypesSucceeded(response)
        )
      )
      .catch(() =>
        dispatch(getFilteredAndPaginatedCustomPaymentTypesFailed())
      )
  }

export const createCustomPaymentType = (data) => (dispatch) => {
  dispatch(createCustomPaymentTypesRequested())

  return api
    .createCustomPaymentType(data)
    .then((response) =>
      dispatch(
        createCustomPaymentTypesSucceeded(
          response?.data?.customPaymentTypes
        )
      )
    )
    .catch(() => dispatch(createCustomPaymentTypesFailed()))
}

export const updateCustomPaymentType = (data) => (dispatch) => {
  dispatch(updateCustomPaymentTypesRequested())

  return api
    .updateCustomPaymentType(data)
    .then((response) =>
      dispatch(
        updateCustomPaymentTypesSucceeded(
          response?.data?.customPaymentTypes
        )
      )
    )
    .catch(() => dispatch(updateCustomPaymentTypesFailed()))
}

export const deleteCustomPaymentType = (uuid) => (dispatch) => {
  dispatch(deleteCustomPaymentTypesRequested())

  return api
    .deleteCustomPaymentType(uuid)
    .then((response) =>
      dispatch(
        deleteCustomPaymentTypesSucceeded(
          response?.data?.customPaymentTypes
        )
      )
    )
    .catch(() => dispatch(deleteCustomPaymentTypesFailed()))
}
